import { request } from "@/Api";
import { FilesStore } from "@/common/FilesUploader";
import { setError } from "@/nav/navSlice";
import { useState } from "react";
import { useDispatch } from "react-redux";

export default function useBidImport({
    projectId,
    onFilesTransfer,
    onImportBidSuccess,
    onImportBidFailed,
}) {
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);
    const filesData = file ? [file] : [];

    const importBidFile = (fileArg) => {
        const formData = new FormData();
        formData.append("sheet_file", fileArg || file);
        formData.append("project_id", projectId || "null");

        request
            .post("/bids/excel-import", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                const bid = response.data;
                onImportBidSuccess && onImportBidSuccess(bid);
            })
            .catch((error) => {
                console.error("Bid import failed:", error);
                dispatch(
                    setError({
                        message: `There was a problem importing the bid sheet. Please ensure the file is correctly formatted and try again: ${error.response?.data?.detail || error.message}`,
                    }),
                );
                onImportBidFailed && onImportBidFailed(error);
            });
    };

    const handleFilesTransfer = (files) => {
        onFilesTransfer && onFilesTransfer(files);
        const file = files[0];
        setFile(file);
    };

    const importBox = (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
            }}
        >
            <div style={{ width: "100%", height: "60%" }}>
                <FilesStore
                    innerTitle={"Drag and drop your excel bid template here"}
                    filesData={filesData}
                    single={true}
                    acceptedFormats={[".xlsx", ".xls"]}
                    onFilesTransfer={handleFilesTransfer}
                />
            </div>
        </div>
    );

    return { importBox, importBidFile, file };
}
